export default __webpack_public_path__ + "static/media/boule.d608f6ea.DAE";